module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/5@1x.png?0.0.53";